import React, { useState } from 'react';
import { useAppSelector } from '../store/hooks';
import { STORAGE_KEYS } from '../utils/localStorage';

export const DebugPanel: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const fillings = useAppSelector(state => state.recipes.fillings);
  const components = useAppSelector(state => state.recipes.components);

  const getLocalStorageData = (key: string) => {
    const data = localStorage.getItem(key);
    if (!data) return null;
    try {
      return JSON.parse(data);
    } catch (e) {
      return data;
    }
  };

  if (!isOpen) {
    return (
      <button
        onClick={() => setIsOpen(true)}
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          padding: '10px 20px',
          backgroundColor: '#2196F3',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          zIndex: 9999
        }}
      >
        Debug Panel
      </button>
    );
  }

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        width: '600px',
        maxHeight: '80vh',
        backgroundColor: 'white',
        border: '2px solid #2196F3',
        borderRadius: '8px',
        padding: '20px',
        overflow: 'auto',
        zIndex: 9999,
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
        <h2 style={{ margin: 0 }}>Debug Panel</h2>
        <button
          onClick={() => setIsOpen(false)}
          style={{
            padding: '5px 15px',
            backgroundColor: '#f44336',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Close
        </button>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h3>Redux State</h3>
        <div style={{ marginBottom: '10px' }}>
          <strong>Fillings in Redux:</strong> {fillings.length}
          <pre style={{ background: '#f5f5f5', padding: '10px', overflow: 'auto', fontSize: '12px' }}>
            {JSON.stringify(fillings, null, 2)}
          </pre>
        </div>
        <div>
          <strong>Components in Redux:</strong> {components.length}
          <pre style={{ background: '#f5f5f5', padding: '10px', overflow: 'auto', fontSize: '12px' }}>
            {JSON.stringify(components, null, 2)}
          </pre>
        </div>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h3>LocalStorage Data</h3>
        <div style={{ marginBottom: '10px' }}>
          <strong>{STORAGE_KEYS.FILLINGS}:</strong>
          <pre style={{ background: '#f5f5f5', padding: '10px', overflow: 'auto', fontSize: '12px' }}>
            {JSON.stringify(getLocalStorageData(STORAGE_KEYS.FILLINGS), null, 2) || 'No data'}
          </pre>
        </div>
        <div style={{ marginBottom: '10px' }}>
          <strong>{STORAGE_KEYS.COMPONENTS}:</strong>
          <pre style={{ background: '#f5f5f5', padding: '10px', overflow: 'auto', fontSize: '12px' }}>
            {JSON.stringify(getLocalStorageData(STORAGE_KEYS.COMPONENTS), null, 2) || 'No data'}
          </pre>
        </div>
        <div>
          <strong>{STORAGE_KEYS.OLD_RECIPES}:</strong>
          <pre style={{ background: '#f5f5f5', padding: '10px', overflow: 'auto', fontSize: '12px' }}>
            {JSON.stringify(getLocalStorageData(STORAGE_KEYS.OLD_RECIPES), null, 2) || 'No data'}
          </pre>
        </div>
      </div>

      <div>
        <h3>All LocalStorage Keys</h3>
        <pre style={{ background: '#f5f5f5', padding: '10px', overflow: 'auto', fontSize: '12px' }}>
          {JSON.stringify(Object.keys(localStorage), null, 2)}
        </pre>
      </div>
    </div>
  );
};
